import { initialState } from '..';
import { maxSelectionsInBetSlip } from '../config';
import type { BetSlipState, Selection } from '../types';

const selectionsAdded = (state: BetSlipState, payload: Selection[]): BetSlipState => {
  if (state.isLocked || state.selections.length >= maxSelectionsInBetSlip) {
    return state;
  }

  const selectionsNotInTheBetSlip = payload.filter(
    (payloadSelection) =>
      !state.selections.find(
        (betSlipSelection) =>
          betSlipSelection.marketId === payloadSelection.marketId &&
          betSlipSelection.selectionId === payloadSelection.selectionId
      )
  );

  if (state.selections.length + selectionsNotInTheBetSlip.length > maxSelectionsInBetSlip) {
    return state;
  }

  const isEverySelectionInTheBetSlip = payload.every((payloadSelection) =>
    state.selections.find(
      (betSlipSelection) =>
        betSlipSelection.selectionId === payloadSelection.selectionId &&
        betSlipSelection.marketId === payloadSelection.marketId
    )
  );

  if (isEverySelectionInTheBetSlip) {
    return state;
  }

  return {
    ...state,
    receipt: initialState.receipt,
    selectedPromotionPicker: initialState.selectedPromotionPicker,
    selections: [...state.selections, ...selectionsNotInTheBetSlip]
  };
};

export default selectionsAdded;
